// @ts-nocheck
// Loading skeletons (docs/miniapp-m7-tz.md §3.3).
//
// Centralised shimmer placeholders so every list screen shows a layout-shaped
// loader instead of a blank flash. `<ScreenSkeleton kind=…>` picks a full-screen
// composition; the named card skeletons (TaskCardSkeleton / DealCardSkeleton /
// AIBlockSkeleton) are reusable inside screens that stream sections in. Shimmer
// is the `.skel` CSS class (styles.css → @keyframes shimmer) — never a static
// grey block.
import { Skel } from './ui'

// ── reusable card skeletons ──────────────────────────────────────────────────

export function TaskCardSkeleton() {
  return (
    <div className="card card-16" style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 8 }}>
      <Skel w={38} h={38} r={10} />
      <div className="flex-1" style={{ minWidth: 0 }}>
        <Skel w="62%" h={13} style={{ marginBottom: 7 }} />
        <Skel w="40%" h={11} />
      </div>
      <Skel w={52} h={22} r={11} />
    </div>
  )
}

export function DealCardSkeleton() {
  return (
    <div className="card card-16" style={{ marginBottom: 8 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', gap: 12, marginBottom: 10 }}>
        <Skel w="55%" h={13} />
        <Skel w={64} h={13} />
      </div>
      <div style={{ display: 'flex', gap: 8 }}>
        <Skel w={74} h={20} r={10} />
        <Skel w={52} h={20} r={10} />
      </div>
    </div>
  )
}

export function AIBlockSkeleton() {
  return (
    <div className="card card-16" style={{ background: 'var(--ai-bg)', marginBottom: 12 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 10 }}>
        <Skel w={20} h={20} r={6} />
        <Skel w="34%" h={12} />
      </div>
      <Skel w="100%" h={11} style={{ marginBottom: 6 }} />
      <Skel w="92%" h={11} style={{ marginBottom: 6 }} />
      <Skel w="60%" h={11} />
    </div>
  )
}

function ListSkeleton({ rows = 5, card: Card = TaskCardSkeleton }) {
  return (
    <>
      {Array.from({ length: rows }, (_, i) => <Card key={i} />)}
    </>
  )
}

// ── full-screen compositions ─────────────────────────────────────────────────

export function ScreenSkeleton({ kind = 'today' }) {
  return (
    <div className="scroll-y" style={{ flex: 1, padding: '12px 16px 24px' }}>
      {kind === 'today' && (
        <>
          <Skel w="44%" h={16} style={{ marginBottom: 6 }} />
          <Skel w="66%" h={12} style={{ marginBottom: 16 }} />
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8, marginBottom: 14 }}>
            {[0, 1, 2, 3].map((i) => <Skel key={i} h={64} r={12} />)}
          </div>
          <Skel w="30%" h={12} style={{ marginBottom: 10 }} />
          <Skel h={132} r={12} style={{ marginBottom: 12 }} />
          {[0, 1, 2].map((i) => <Skel key={i} h={66} r={12} style={{ marginBottom: 8 }} />)}
        </>
      )}

      {kind === 'deals' && (
        <>
          <Skel w="40%" h={16} style={{ marginBottom: 14 }} />
          <ListSkeleton rows={6} card={DealCardSkeleton} />
        </>
      )}

      {kind === 'calls' && (
        <>
          <Skel w="36%" h={16} style={{ marginBottom: 14 }} />
          <ListSkeleton rows={5} card={TaskCardSkeleton} />
        </>
      )}

      {kind === 'list' && (
        <>
          <Skel w="40%" h={16} style={{ marginBottom: 14 }} />
          <ListSkeleton rows={5} card={TaskCardSkeleton} />
        </>
      )}

      {kind === 'detail' && (
        <>
          <Skel w="60%" h={18} style={{ marginBottom: 8 }} />
          <Skel w="38%" h={12} style={{ marginBottom: 18 }} />
          <AIBlockSkeleton />
          <Skel w="100%" h={11} style={{ marginBottom: 7 }} />
          <Skel w="88%" h={11} style={{ marginBottom: 7 }} />
          <Skel w="72%" h={11} style={{ marginBottom: 18 }} />
          {[0, 1, 2].map((i) => <Skel key={i} h={56} r={12} style={{ marginBottom: 8 }} />)}
        </>
      )}
    </div>
  )
}
